import React, { useEffect, useState } from 'react';
import { Table, Row, Col, message, Button } from 'antd';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { connect } from 'react-redux';
import { fetchRateCardValue, updateRateCardValue, resetUpdateRateCardValue } from 'appRedux/actions/RateCardValue';
import Widget from 'components/Widget';
import { EditableCell, EditableFormRow } from './EditableCell';
import RateCardValueColumns from './RateCardValueColumns';
import convertData from 'firebase/utils/convertData';

const DataDefine = ({
  currentUser,
  fetchRateCardValue,
  updateRateCardValue,
  rateCardValueList,
  loadingRateCardValue,
  updatingRateCardValue,
  payloadRateCardValue,
  resetUpdateRateCardValue,
}) => {
  const [rateCardValueDataSource, setRateCardValueDataSource] = useState([]);
  const [disableSubmitRateCardValue, setDisableSubmitRateCardValue] = useState(false);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };


  const isNotAllowSubmitRateCardValue = loadingRateCardValue || disableSubmitRateCardValue;

  const rateCardValueColumns = RateCardValueColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRowRateCardValue,
        handleError: handleErrorRateCardValue,
      }),
    };
  });

  

  const handleUpdateRowRateCardValue = row => {
    const newData = [...rateCardValueDataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setRateCardValueDataSource(newData);
  };

  const handleSaveRateCardValue = e => {
    e.preventDefault();
    rateCardValueDataSource.forEach((_, i) => { rateCardValueDataSource[i].created_at = moment().unix(); rateCardValueDataSource[i].created_by = currentUser; } );
    message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
    updateRateCardValue(rateCardValueDataSource);
  };

  const handleErrorRateCardValue = (isDisabled) => {
    setDisableSubmitRateCardValue(isDisabled);
  };

  useEffect(() => {
    fetchRateCardValue();
  }, [fetchRateCardValue]);

  useEffect(() => {
    if (payloadRateCardValue.message) {
      message.success({ content: payloadRateCardValue.message, key: 'updatable', duration: 2  });
      resetUpdateRateCardValue();
    }
  }, [payloadRateCardValue, resetUpdateRateCardValue]);

  useEffect(() => {
    if (!loadingRateCardValue && !isEmpty(rateCardValueList)) {
      const convertedData = isEmpty(rateCardValueList) ? [] : convertData(rateCardValueList, true);
      const sortedData = orderBy(convertedData, ['department'],['asc']);
      setRateCardValueDataSource(sortedData);
    }
  }, [loadingRateCardValue, rateCardValueList]);
  
  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">People Rate Card</h2>}
          >
            <Table
              rowKey='position'
              loading={loadingRateCardValue}
              pagination={false}
              bordered
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={rateCardValueDataSource}
              columns={rateCardValueColumns}
            />
            <div className='save-segment'>
              <Button disabled={isNotAllowSubmitRateCardValue} loading={updatingRateCardValue} icon='vertical-align-bottom' size='large' onClick={handleSaveRateCardValue} type="primary">
                Save
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ rateCard, rateCardValue, freq, industry, category, peopleLevelInBrand, peopleLevelInCampaign, auth }) => {
  const { currentUser } = auth;
  const { data: rateCardValueList, loading: loadingRateCardValue, updating: updatingRateCardValue, payload: payloadRateCardValue } = rateCardValue;
  return { currentUser, rateCardValueList, loadingRateCardValue, updatingRateCardValue, payloadRateCardValue };
};

export default connect(
  mapStateToProps,
  {
    fetchRateCardValue,
    updateRateCardValue,
    resetUpdateRateCardValue,
  },
)(DataDefine);
